<template>
  <div>
    <a-modal
      :title="modalTitle"
      v-model="visible" 
      @cancel="handleCancel" 
      width="850px"
      v-bind:body-style="{ height: '100%' }"
    >
        <!-- 表头 -->
        <div class="content_one">
          <div class="form_title"> 收货地址</div>
        </div>
        
          <!-- 表格 -->
          <a-table
            class="antd-table"
            bordered
            :columns="relevanceBatch_grid.field"
            :data-source="relevanceBatch_grid.row"
            rowKey="id"
            size="small"
            :scroll="{ y: relevanceBatch_grid.height,x:relevanceBatch_grid.width}"
            :pagination="false"
          >
            <!-- 序号 -->
            <span slot="index" slot-scope="text, record, index">
              {{1}}
            </span>
          </a-table>
    
          <!-- 表头 -->
          <div class="content_one">
          <div class="form_title">商品信息</div>
        </div>
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_gridTwo.field"
          :data-source="relevanceBatch_gridTwo.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_gridTwo.height,x:relevanceBatch_gridTwo.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{1}}
          </span>
         <!-- 商品图片 -->
          <span slot="prAttId" slot-scope="text, record">
              <img
                style="height: 50px;max-width: 100%; margin-right: 4px"
                :src="url + record.prAttId"
                @click="handleImg(record.prAttId)"
              />
          </span>
        </a-table>

        <a-modal
          :visible="previewVisible"
          :footer="null"
          @cancel="handleCancelImg"
          class="imgBox"
        >
          <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>

         <!-- 表头 -->
         <div class="content_one">
          <div class="form_title">实体卡信息</div>
        </div>
        <a-table
          class="antd-table"
          bordered
          :columns="relevanceBatch_gridThree.field"
          :data-source="relevanceBatch_gridThree.row"
          rowKey="id"
          size="small"
          :scroll="{ y: relevanceBatch_gridThree.height,x:relevanceBatch_gridThree.width}"
          :pagination="false"
        >
          <!-- 序号 -->
          <span slot="index" slot-scope="text, record, index">
            {{1}}
          </span>
        </a-table>

        <div class="content_one">
          <div class="form_title">物流信息</div>
        </div>

        <div >
          <a-form-model :label-col="labelCol" :wrapper-col="wrapperCol" :model="searchList" :rules="rules" ref="ruleForm">
            <a-col :span = "12">
            <a-form-model-item label="物流公司:" prop="logisticsComp">
            <a-input v-model="searchList.logisticsComp" :allowClear="true" placeholder="请输入物流公司"/>
          </a-form-model-item>
          </a-col>
          <a-col :span = "12">
            <a-form-model-item label="运单号:" prop="waybillNum">
            <a-input v-model="searchList.waybillNum" :allowClear="true" placeholder="请输入运单号" />
          </a-form-model-item>
          </a-col>
          </a-form-model>
        </div>
    <template #footer>
      <!-- 底部按钮区域 -->
      <a-button  type="primary" ghost @click="handleCancel">取消</a-button>
      <a-button  type="primary" @click="handleOk" :loading="okLoad">确定</a-button>
    </template>
    </a-modal>
  </div>
</template>

<script>
import { sendLogistics,toSendLogistics} from "@/api/api.js";
export default {
  components: {
  },
  props: {
    modalTitle: {
      type: String,
      default: () => "",
    }, //标题
    giftId: {
      type: String,
      default: () => "",
    },//返回信息
  },

  data() {
    return {
      visible: true,
      previewVisible: false,
      previewImage: "",
      url: "",
      //固定宽度
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },

      relevanceBatch_grid: {
        height: "200",
        width: 0, // 宽度
        row: [],
        field: [
        {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 50,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "收货人",
            align: "center",
            width: 140,
            dataIndex: "consignee",
          },
          {
            title: "手机号",
            align: "center",
            width: 140,
            dataIndex: "phoneNo",
            ellipsis: true,
          },
          {
            title: "收货地址",
            align: "center",
            width: 230,
            dataIndex: "address",
            ellipsis: true,
          }
        ]
      },
      relevanceBatch_gridTwo: {
        height: "200",
        width: 0, // 宽度
        row: [],
        field: [
          {
            title: "商品图片",
            align: "center",
            width: 120,
            dataIndex: "prAttId",
            scopedSlots: { customRender: "prAttId" },
          },
          {
            title: "商品名称",
            align: "center",
            width:160,
            dataIndex: "prName",
            ellipsis: true,
          },
          {
            title: "商品说明",
            align: "center",
            width: 100,
            dataIndex: "remark",
            ellipsis: true,
          },
          {
            title: "商品单价",
            align: "center",
            width: 100,
            dataIndex: "prPrice",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            width: 90,
            dataIndex: "giftCount",
            align: "center",
            ellipsis: true,
          },
          {
            title: "小计",
            colSpan: 1,
            width: 90,
            dataIndex: "giftPrice",
            align: "center",
            ellipsis: true,
          }
        ]
      },
      relevanceBatch_gridThree: {
        height: "200",
        width: 0, // 宽度
        row: [],
        field: [
        {
            title: "序号",
            align: "center",
            dataIndex: "index",
            width: 50,
            key: "index",
            ellipsis: true,
            scopedSlots: { customRender: "index" },
          },
          {
            title: "实体卡图片",
            align: "center",
            width: 120,
            dataIndex: "attId",
            scopedSlots: { customRender: "attId" },
          },
          {
            title: "实体卡说明",
            align: "center",
            width:160,
            dataIndex: "cardName",
            ellipsis: true,
          },
          {
            title: "卡编号",
            align: "center",
            width: 100,
            dataIndex: "cardNo",
            ellipsis: true,
          },
          {
            title: "数量",
            colSpan: 1,
            width: 90,
            dataIndex: "count",
            align: "center",
            ellipsis: true,
          }
        ]
      },

      //绑定值
      searchList: {
        giftId:this.giftId,
        logisticsComp: "",
        waybillNum:"",
      },
      //校验规则
      rules: {
        logisticsComp: [
          {
            required: true,
            message: "物流公司不能为空！",
            trigger: "blur",
          },
          {
            max: 100,
            message: "不可超过100字",
            trigger: "blur",
          }
        ],
        waybillNum: [
          {
            required: true,
            message: "运单号不能为空！",
            trigger: "blur",
          },
          {
            max: 50,
            message: "不可超过50字",
            trigger: "blur",
          },
        ],
      },
      okLoad:false,
      giftApply:[],
      receivAddressList:[],
    }
  },
  mounted() {
    //查询
    this.queryList();
    this.relevanceBatch_grid.width = 0;
    this.relevanceBatch_grid.field.map(item => {
      this.relevanceBatch_grid.width += item.width;
    });

    this.relevanceBatch_gridTwo.width = 0;
    this.relevanceBatch_gridTwo.field.map(item => {
      this.relevanceBatch_gridTwo.width += item.width;
    });

    
    this.relevanceBatch_gridThree.width = 0;
    this.relevanceBatch_gridThree.field.map(item => {
      this.relevanceBatch_gridThree.width += item.width;
    });
  },
  methods: {
    /* 表格图片查看 */
    handleImg(file) {
        this.previewVisible = true;
        this.bigurl = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
        this.previewImage = this.bigurl + file;
      },
      /* 表格图片关闭 */
      handleCancelImg() {
        this.previewVisible = false;
      },
     //查询接口
     queryList() {
      this.receivAddressList=[];
      this.giftApply = [];
      this.url = process.env.VUE_APP_PROXY + "base/file/download-file?id=";
      toSendLogistics( {giftId:this.giftId }).then(res => {
        this.receivAddressList.push(res.content.receivAddress);
        this.relevanceBatch_grid.row = this.receivAddressList;
        res.content.giftApply.prAttId =  res.content.prAttId;
        res.content.giftApply.prPrice =  res.content.prPrice;
        res.content.giftApply.address=res.content.giftApply.address+res.content.giftApply.receivAddress;
        this.giftApply.push(res.content.giftApply);
        this.relevanceBatch_gridTwo.row = this.giftApply;
        res.content.phyOrderList.forEach(element => {
          element.count='1'
          });
        this.relevanceBatch_gridThree.row = res.content.phyOrderList;
      });
    },
 
    //取消
    handleCancel() {
      //关闭弹窗
      this.$emit("close");
    },

    //保存
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.okLoad = true
          sendLogistics(this.searchList).then(
            (res) => {
              if (res.code == '0000') {
                this.okLoad = false;
                this.$message.success('发货成功');
                this.$emit('handleOk');
              }
            },
            (err) => {
              this.okLoad = false
              this.$message.error('发货异常，请联系管理员')
            }
            )
        };
      })
    },

  },
}
</script>

<style lang="less" scoped>
 .form_title{
  margin-bottom: 0px !important;
  display: flex;
  align-items: center;
  height: 14px;
  color: #333;
  padding-left: 5px;
  font-size: 14px;
  border-left: 4px solid #16828b;
}

      .content_one {
        height: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
/deep/  .ant-modal-body {
    padding: 24px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    padding-top: 0px !important;
}
.button-save {
  border: none;
  background: #009de5;
  color: #fff;
  width: 90px;
  height: 30px;
}

.button-cancel {
  border: 1px #cccccc solid;
  background: #fff;
  color: #333;
  width: 90px;
  height: 30px;
}

/deep/ .ant-modal-body {
    overflow-y: auto;
}
</style>
